<template>
  <q-form ref="formRef" greedy>
    <div class="text-h5 text-bold">分割線</div>
    <div class="text-subtitle2">分割線のスタイル・アクション設定</div>
    <div class="row q-mt-md">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>タイプ<span class="text-brand-red">*</span></div>
        <div class="text-caption">Type</div>
      </div>
      <q-select
        outlined
        dense
        emit-value
        map-options
        v-model="value.type"
        :options="typeList"
        class="col"
        disable
      >
        <template v-slot:selected-item="scope">
          <div class="column">
            <div>{{ scope.opt.label }}</div>
            <div class="text-caption">{{ scope.opt.value }}</div>
          </div>
        </template>
      </q-select>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>マージン</div>
        <div class="text-caption">margin</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.margin"
        placeholder="XXpx"
        :rules="[
          (val) => pxKeywordValidate(val) || 'invalid property',
        ]"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-btn-dropdown
            no-caps
            unelevated
            color="brand-grey"
            label="px or keywords"
          >
            <q-list>
              <q-item
                v-for="(item, index) in marginList"
                clickable
                v-close-popup
                :key="index"
                @click="value.margin = item"
              >
                <q-item-section>
                  <q-item-label>{{ item }}</q-item-label>
                </q-item-section>
              </q-item>
            </q-list>
          </q-btn-dropdown>
        </template>
      </q-input>
    </div>
    <div class="row q-mt-sm">
      <div class="q-mr-md text-grey-9 col-2 column items-end justify-center">
        <div>カラー</div>
        <div class="text-caption">color</div>
      </div>
      <q-input
        outlined
        dense
        v-model="value.color"
        :rules="[
          (val) => colorValidate(val) || 'invalid property',
        ]"
        placeholder="#FFFFFF"
        class="col flex-input"
      >
        <template v-slot:append>
          <q-icon name="colorize" class="cursor-pointer">
            <q-popup-proxy cover transition-show="scale" transition-hide="scale">
              <q-color no-header no-footer v-model="value.color" />
            </q-popup-proxy>
          </q-icon>
        </template>
      </q-input>
    </div>
  </q-form>
</template>

<script lang="ts">
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop, Watch } from 'vue-property-decorator'
import { IFlexMessageSeparator } from '@/utils/types'

@Options({
  components: {},
  directives: { maska },
  emits: ['update:modelValue', 'update:validateValue'],
})
export default class Separator extends Vue {
  @Prop()
  modelValue!: IFlexMessageSeparator

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageSeparator) {
    this.$emit('update:modelValue', value)
  }

  get typeList() {
    return [
      {
        label: '分割線',
        value: 'separator',
      },
    ]
  }

  get marginList() {
    return ['none', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl']
  }

  pxKeywordValidate(val) {
    if (!val) return true

    const isPx = /^\d+(\.\d+)?px$/.test(val)
    const isKeyword = this.marginList.includes(val)
    return !(!isPx && !isKeyword)
  }

  colorValidate(val) {
    if (!val) return true
    return /^#[0-9A-Fa-f]{6}([0-9A-Fa-f]{2})?$/.test(val)
  }

  @Watch('value', { deep: true })
  async validate() {
    await this.$nextTick(async () => {
      const isValid = await this.$refs.formRef.validate()
      if (isValid) {
        this.$emit('update:validateValue', true)
      } else {
        this.$emit('update:validateValue', false)
      }
      return isValid
    })
  }

  mounted() {
    this.validate()
  }
}
</script>

<style scoped lang="scss">

</style>
